import { RCFormData } from "./ChatFormStore";

export const chatFormNames = {
  message: "message",
  file: "file",
  description: "description",
} satisfies Record<keyof RCFormData, string>;
